module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAYAAACALL/6AAAAUElEQVQYlZWPUQ4AIAhCqZNxdG5WXzVTWosvp48JTdLAh/oaSIJkAfJ+GyRtIMLxBgAtR8pfInx8cECGrcFFuhpiZtfpMLiCzlRKv1Q6vDQB7OUnz0f2FD0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/CLOSE.png
// module id = 50
// module chunks = 0